import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

// POS-terminal (Plan B, B4): the web till and its receipt, full screen (outside MainLayout),
// mounted with the other standalone print routes (authenticated, see App.tsx).
const PosTillPage = lazy(() => import('./till/PosTillPage'));
const ReceiptPage = lazy(() => import('./till/ReceiptPage'));

const posTillRoutes: RouteObject[] = [
  { path: '/pos/till', element: <PosTillPage /> },
  { path: '/pos/receipt/:autoId', element: <ReceiptPage /> },
];

export default posTillRoutes;
